// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class PrePayService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  prepayContractData: any;
  selectedAccount: number;
  accountNo: number;

  getPrePayContractData() {
    return this.prepayContractData;
  }
  setPrepayContractData(contractData) {
    this.prepayContractData = contractData;
  }

  // Get Active Pending Closed Data
  public getActivePendingClosedContractsData(data: any) {
    return this.networkService.postRequest(this.configService.getActivePendingClosedContractsDataUrl(), data);
  }

  // Get Contract List Data
  public getContractsDetailsData(data: any) {
    return this.networkService.postRequest(this.configService.getContractDetailDataUrl(), data);
  }

  // Get Account list
  public getAccountList(dashboardFilter) {
    return this.networkService.getRequest(this.configService.getFilterDataPrepayUrl() + '?cropYear=' + dashboardFilter.cropYear);
  }

  // Get Seed PrePay List Data
  public getSeedPrePayContractData(data) {
    return this.networkService.getRequest(this.configService.getSeedPrePayContractDataUrl() + '?requestdate=' + data.requestdate + '&businessline=' + data.businessline + '&accountnumber=' + data.accountnumber + '&startingcropyear=' + data.startingcropyear);
  }

  // Cancel request
  public cancelContractRequest(data) {
    return this.networkService.postRequest(this.configService.cancelContractRequestUrl(), data);
  }
  // Add update contract request
  public addUpdateContractRequest(data: any) {
    return this.networkService.postRequest(this.configService.addUpdateContractRequestUrl(), data);
  }

  // Get Prepay Detail Data
  public getPrepayDetailData(contractNumber, businessLine, userReserved, accountNo, fromDate, toDate) {
    return this.networkService.getRequest(this.configService.getPrepayDetailDataUrl() + '?contractNumber=' + contractNumber + '&businessLine=' + businessLine + '&userReserved=' + userReserved + '&accountNo=' + accountNo + '&fromDate=' + fromDate + '&toDate=' + toDate);
  }

  // Get Crop year Data
  public getCropYearData() {
    return this.networkService.getRequest(this.configService.getCropYearDataUrl());
  }

  // For downloading terms and conditions from Media object table
  public getTermsAndConditionByRefrenceName(refrenceName) {
    return this.networkService.getRequest(this.configService.getTermsAndConditionByRefrenceName() + '?referenceName=' + refrenceName);
  }
}
